
import React from 'react'
import PageWrapper from '../../Components/Other/PageWrapper'
import { useEffect } from 'react';
import DetailHeader from '../../Components/DiseaseDetail/DetailHeader'
function UrinaryIncontinence(props) {
    useEffect(() => {

    })
    return (
        <PageWrapper className={"dis-05-autism-page"}>
            <>
                {/*?php include 'header.php'; ?*/}
                <div className="pageWrapper">
                    <DetailHeader diseaseName={"Urinary incontinence "}></DetailHeader>
                    <div className="MainContent">
                        <div className="container">
                            <div className="page-rte">
                                <p>
                                    Urinary incontinence means<b> a person leaks urine by accident.</b> While it
                                    may happen to anyone, urinary incontinence is more common in older
                                    people, especially women. Incontinence can often be cured or
                                    controlled. Talk to your healthcare provider about what you can do.
                                </p>

                                <div className="row">
                                    <div className="col-12 textCenter">
                                        <img src={require("../../img/Disease/Urinary-incontinence/1.png")} alt="Urinary-incontinence" />
                                    </div>
                                </div>
                                <br></br>
                                <p><b>Types of urinary incontinence include: </b></p>
                                <p><b>Stress incontinence: </b>
                                    Urine leaks when you exert pressure on your bladder by coughing,
                                    sneezing, laughing, exercising or lifting something heavy.
                                </p>
                                <p><b>Urge incontinence: </b>
                                    You have a sudden, intense urge to urinate followed by an involuntary
                                    loss of urine. You may need to urinate often, including throughout the night. Urge
                                    incontinence may be caused by a minor condition, such as infection, or a more severe
                                    condition such as a neurological disorder or diabetes.
                                </p>
                                <p><b>Overflow incontinence: </b>
                                    You experience frequent or constant dribbling of urine due to a
                                    bladder that doesn't empty completely.
                                </p>
                                <p><b>Functional incontinence: </b>
                                    A physical or mental impairment keeps you from making it to the
                                    toilet in time. For example, if you have severe arthritis, you may not be able to unbutton your
                                    pants quickly enough.
                                </p>
                                <p><b>Mixed incontinence: </b>
                                    You experience more than one type of urinary incontinence — most
                                    often this refers to a combination of stress incontinence and urge incontinence.
                                </p>
                                <a className="links" href="https://en.wikipedia.org/wiki/Urinary_incontinence">
                                    For More Details
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
                {/*?php include 'footer.php'; ?*/}
            </>

        </PageWrapper>
    );
}

export default UrinaryIncontinence;